// import constant
import {
    SET_CMS_DATA,
    SET_CMS_LIST_LOADED,
} from '../constants';

const initialValue = {
    isAuthenticated: false,
    cmsData: [],
    cmsListLoaded: false,
};
const cmsData = (state = initialValue, action) => {
    switch (action.type) {

        case SET_CMS_DATA:
            return {
                ...state,
                cmsData: action.data,
            };

        case SET_CMS_LIST_LOADED:
            return {
                ...state,
                cmsListLoaded: true,
            };

        default:
            return state;
    }
}

export default cmsData;